import React from 'react';
import { RightOutlined, ScheduleOutlined } from '@ant-design/icons';

const filterOptionStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px',
  borderBottom: '1px solid #ddd',
  cursor: 'pointer',
};

const FilterContent = ({ handleFilterChange, aggregationAttribute }) => {
  const validImpactAttributes = [
    'plannedImpactTotal',
    'leImpactTotal',
    'actualImpactTotal',
    'plannedImpactTotalExcl',
    'actualImpactTotalExcl',
    'leImpactTotalExcl',
    'plannedKPI',
    'plannedDepositKPI',
    'plannedLoanKPI',
    'plannedFinancingKPI',
    'plannedFCYKPI',
    'actualKPI',
    'actualDepositKPI',
    'actualLoanKPI',
    'actualFinancingKPI',
    'actualFCYKPI'
  ];

  // ✅ CORRECTED: Use .some() to check if any element of aggregationAttribute is a valid impact attribute
  const showFilterByPeriod = Array.isArray(aggregationAttribute) && aggregationAttribute.some(attr => validImpactAttributes.includes(attr));

  return (
    <div style={{ padding: '10px' }}>
      <div
        style={filterOptionStyle}
        onClick={() => {
          handleFilterChange('initiative');
        }}
      >
        <span>Filter by Initiative</span>
        <RightOutlined />
      </div>

      <div
        style={filterOptionStyle}
        onClick={() => {
          handleFilterChange('impact');
        }}
      >
        <span>Filter by Impact</span>
        <RightOutlined />
      </div>

      <div
        style={filterOptionStyle}
        onClick={() => {
          handleFilterChange('milestone');
        }}
      >
        <span>Filter by Milestone</span>
        <RightOutlined />
      </div>

      <div
        style={filterOptionStyle}
        onClick={() => {
          handleFilterChange('kpi');
        }}
      >
        <span>Filter by KPI</span>
        <RightOutlined />
      </div>

      <div
        style={filterOptionStyle}
        onClick={() => {
          handleFilterChange('workstreamAction');
        }}
      >
        <span>Filter by Workstream action</span>
        <RightOutlined />
      </div>

      {/* Use the new showFilterByPeriod variable to conditionally render */}
      {showFilterByPeriod && (
        <div
          style={filterOptionStyle}
          onClick={() => {
            handleFilterChange('period');
          }}
        >
          <span>Filter by Period</span>
          <ScheduleOutlined />
        </div>
      )}
    </div>
  );
};

export default FilterContent;